import ResponseAttribution from "./ResponseAttribution";
import ResponseText from "./ResponseText";
import { useEffect, useState } from "react";
import { collection, getDocs } from "firebase/firestore";
import { db } from "../../../../../backend/firebaseConfig";
import dayjs from "dayjs";
import "../../../../../css/Compliance/Chatbot/CachedResponses.css"; 
import { useUserPermissions } from "../../../../SignIn/UserPermissionsContext";
// import highlightText from "../../utils/HighlightSearchText";

const ApprovedResponses = ({ searchTerm = "" }) => {
  const [responses, setResponses] = useState([]);
  const { userPermissions } = useUserPermissions();
  const isAdmin = userPermissions.includes("Administrator");

  useEffect(() => {
    const fetchResponses = async () => {
      const snapshot = await getDocs(
        collection(db, "Compliance", "Cached Responses", "Responses")
      );
      const data = snapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));

      const sorted = data.sort((a, b) => {
        const dateA = new Date(a.timestamp);
        const dateB = new Date(b.timestamp);
        return dateB - dateA;
      });

      setResponses(sorted);
    };

    fetchResponses();
  }, []);

  // Filter based on search term
  const filteredResponses = responses.filter(({ question, answer }) => {
    const lowerTerm = searchTerm.toLowerCase();
    return (
      question?.toLowerCase().includes(lowerTerm) ||
      answer?.toLowerCase().includes(lowerTerm)
    );
  });

  return (
    <div className="chatbot-responses table-scroll-container">
      <table className="website-table ain-history-table"><thead>
      <tr >
        <th className="FP_Help_Text_Semibold table-index-column"></th>
        <th className="FP_Help_Text_Semibold">PROMPT</th>
        <th className="FP_Help_Text_Semibold">RESPONSE</th>
      </tr></thead><tbody>
      {filteredResponses.map(
        (
          { id, question, answer, timestamp, approvedBy, requestedBy },
          index
        ) => (
          <tr  key={id}>
            <td className="FP_Content table-index-column">
              {index + 1}.
            </td>

            <td className="FP_Content">
              <div className="Content">
                {question}
              </div>
              {isAdmin && (
                <ResponseAttribution label="Approved by" value={approvedBy} />
              )}
              {isAdmin && (
                <ResponseAttribution label="Requested by" value={requestedBy} />
              )}
              {isAdmin && (
                <div className="Content-Small">
                  {dayjs(timestamp).format("DD/MM/YYYY")}
                </div>
              )}
            </td>
            <td className="FP_Content"><ResponseText answer={answer} /></td>
          </tr>
        )
      )}</tbody></table>
    </div>
  );
};

export default ApprovedResponses;
